module.exports = "/_next/static/images/bf-5cfc3ec8f3ec00b0e5d69e9423c01412.svg";